/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Admin_Billing_Alltime_WaivedInputs */



/**
* | output |
* | --- |
* | "{amount} waived, not billed" |
*
* @param {Admin_Billing_Alltime_WaivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_billing_alltime_waived = /** @type {((inputs: Admin_Billing_Alltime_WaivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Alltime_WaivedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} erlassen, nicht berechnet`)
	return /** @type {LocalizedString} */ (`${i?.amount} waived, not billed`)
});